import { purify, theme } from '@vfit/shared/themes';
import ShadowsGroup from '../ShadowsGroup/shadowsGroup';
import Inflation from '../Inflation/inflation';
import { I_ConsumerOfferCard } from './consumerOfferCard.models';
import {
  OfferCardContainer,
  OfferCategory,
  Price,
  PricesContainer,
  ProductSubPrice,
  ShoppingCartItem,
  ShoppingCartItemContent,
  ShoppingCartItemDescription,
  ShoppingCartItemIcon,
  ShoppingCartItemTitle,
  ShoppingCartItemTitleRow,
  ShoppingCartListContainer,
  SubDescription,
} from './consumerOfferCard.style';
import ConsumerOfferPromotion from '../ConsumerOfferPromotion/consumerOfferPromotion';
import { Svg } from '@vfit/shared/atoms';
import { ProductCardSpecItemAction } from '../Inflation/inflation.style';
import { Fragment, useState } from 'react';
import ConsumerVodafoneModal from '../ConsumerVodafoneModal/consumerVodafoneModal';

const ConsumerOfferCard = ({
  offer,
  isLoading,
  mapConfig,
  isAlternativeOffer = false,
  inflation,
  isGlobalPromoActive,
  isConsumer = false,
  technologyShoppingCartInfo,
}: I_ConsumerOfferCard) => {
  const {
    productCategory,
    originalPrice,
    currentPrice,
    productSubPrice,
    productDescription,
    promoList,
    offerShoppingCartInfo,
  } = offer;

  const {
    title: technologyTitle,
    description: technologyDescription,
    info: technologyInfo,
  } = technologyShoppingCartInfo ?? {};

  const [purifiedCurrentPrice] = purify([currentPrice || '']);
  const [purifiedProductDescription] = purify([productDescription || '']);
  const [purifiedProductSubPrice] = purify([productSubPrice || '']);

  const [modal, setModal] = useState({
    show: false,
    text: '',
    title: '',
  });

  const onCloseModal = () => {
    setModal({
      show: false,
      text: '',
      title: '',
    });
  };

  return (
    <OfferCardContainer>
      {isLoading ? (
        <ShadowsGroup />
      ) : (
        <>
          {productCategory && <OfferCategory>{productCategory}</OfferCategory>}
          {(originalPrice || currentPrice) && (
            <PricesContainer>
              {originalPrice && <del>{originalPrice}</del>}
              {purifiedCurrentPrice && (
                <Price
                  dangerouslySetInnerHTML={{
                    __html: purifiedCurrentPrice,
                  }}
                />
              )}
            </PricesContainer>
          )}

          {purifiedProductSubPrice && (
            <ProductSubPrice
              dangerouslySetInnerHTML={{
                __html: purifiedProductSubPrice,
              }}
            />
          )}

          {purifiedProductDescription && (
            <SubDescription
              dangerouslySetInnerHTML={{
                __html: purifiedProductDescription,
              }}
            />
          )}

          {inflation &&
            inflation[0]?.text &&
            !isGlobalPromoActive &&
            inflation.map((inf) => (
              <Inflation
                key={inf?.text}
                InflationTitle={inf?.text}
                popup={inf?.popup}
                color={'green'}
                inflationDisclaimer={inf?.disclaimer}
                isConsumer={isConsumer}
              />
            ))}

          {((offerShoppingCartInfo && offerShoppingCartInfo?.length > 0) || technologyTitle) && (
            <>
              <ShoppingCartListContainer>
                {offerShoppingCartInfo
                  ?.filter(({ isFromTechnology }) => isFromTechnology !== 'true')
                  .map(({ title, description, controlActionInfo }, index) => {
                    const controlActionTitle = controlActionInfo?.title;
                    const controlActionDescription = controlActionInfo?.description;
                    if (!title) return null;
                    const hasControlActionInfo = controlActionTitle || controlActionDescription;

                    return (
                      <Fragment key={`${title}-${index}`}>
                        <ShoppingCartItem>
                          <ShoppingCartItemIcon>
                            <Svg
                              name="tick"
                              height={24}
                              width={24}
                              color={theme.colors.text.primary}
                            />
                          </ShoppingCartItemIcon>

                          <ShoppingCartItemContent>
                            <ShoppingCartItemTitleRow>
                              {title && <ShoppingCartItemTitle>{title}</ShoppingCartItemTitle>}

                              {hasControlActionInfo && (
                                <div
                                  className="tooltip"
                                  role="presentation"
                                  onClick={() => {
                                    setModal({
                                      title: controlActionTitle,
                                      text: controlActionDescription,
                                      show: true,
                                    });
                                  }}
                                >
                                  <ProductCardSpecItemAction>
                                    {isConsumer ? <Svg name="info" height={16} width={16} /> : '+'}
                                  </ProductCardSpecItemAction>
                                </div>
                              )}
                            </ShoppingCartItemTitleRow>

                            {description && (
                              <ShoppingCartItemDescription
                                dangerouslySetInnerHTML={{ __html: description }}
                              />
                            )}
                          </ShoppingCartItemContent>
                        </ShoppingCartItem>
                      </Fragment>
                    );
                  })}

                {technologyTitle && (
                  <ShoppingCartItem>
                    <ShoppingCartItemIcon>
                      <Svg name="tick" height={24} width={24} color={theme.colors.text.primary} />
                    </ShoppingCartItemIcon>

                    <ShoppingCartItemContent>
                      <ShoppingCartItemTitleRow>
                        {technologyTitle && (
                          <ShoppingCartItemTitle>{technologyTitle}</ShoppingCartItemTitle>
                        )}

                        {technologyInfo && (
                          <div
                            className="tooltip"
                            role="presentation"
                            onClick={() => {
                              setModal({
                                title: technologyInfo?.title,
                                text: technologyInfo?.description,
                                show: true,
                              });
                            }}
                          >
                            <ProductCardSpecItemAction>
                              {isConsumer ? <Svg name="info" height={16} width={16} /> : '+'}
                            </ProductCardSpecItemAction>
                          </div>
                        )}
                      </ShoppingCartItemTitleRow>

                      {technologyDescription && (
                        <ShoppingCartItemDescription
                          dangerouslySetInnerHTML={{ __html: technologyDescription }}
                        />
                      )}
                    </ShoppingCartItemContent>
                  </ShoppingCartItem>
                )}
              </ShoppingCartListContainer>
              <ConsumerVodafoneModal
                isModalShown={modal.show}
                onCloseModal={onCloseModal}
                purifiedModalTitle={modal.title}
                purifiedModalText={modal.text}
              />
            </>
          )}

          <ConsumerOfferPromotion
            promoList={promoList}
            mapConfig={mapConfig}
            isAlternativeOffer={isAlternativeOffer}
            inflation={inflation}
            isGlobalPromoActive={isGlobalPromoActive}
            isConsumer={isConsumer}
          />
        </>
      )}
    </OfferCardContainer>
  );
};

export default ConsumerOfferCard;

